module.exports = __webpack_public_path__ + "img/favicon.16fc8a87.ico";